export enum DoorEdge {
  BEVBEV = 'Bevel Lock/ Bevel Hinge',
  BEVSQ = 'Bevel Lock/ Square Hinge',
  SQSQ = 'Square Lock/ Square Hinge',
}
